import { Header } from '@trinity/chat-components/components/Modal/Header.js';
import { useModal } from '@trinity/chat-components/components/Modal/hooks/index.js';
import type { ModalProps } from '@trinity/chat-components/components/Modal/Modal.js';
import { Modal } from '@trinity/chat-components/components/Modal/Modal.js';
import styles from './style/Validations.Modal.module.css';

type Props = {
  items: {
    fileName: string;
    errors: string[];
  }[];
} & Pick<ModalProps, 'open' | 'onClose'>;

export const FilesUploadValidationsModal = ({ items, onClose, open }: Props) => {

  return (
    <Modal onClose={onClose} open={open}>
      <Header text="Upload Errors" />

      <div className={styles.message}>
        {`The file(s) you selected couldn't be uploaded because of the following issues:`}
      </div>

      <div className={styles.items}>
        {items.map((item, i) => (
          <div key={i} className={styles.item}>
            <div className={styles.name}>{item.fileName}</div>
            <div className={styles.error}>{item.errors[0]}</div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export const useFilesUploadValidationsModal = () => useModal(FilesUploadValidationsModal);